module.exports = __webpack_public_path__ + "img/updatePass3.0a2b6769.png";